const principles = [
  {
    icon: "ri-archive-drawer-line",
    title: "真实归档",
    desc: "只收录真实存在的老作品，年代与来源如实标注，不虚构、不臆造。",
  },
  {
    icon: "ri-restart-line",
    title: "尽力修复",
    desc: "对老片源做逐帧清理与版本对照，画质状态如实公开，绝不伪装高清。",
  },
  {
    icon: "ri-team-line",
    title: "众人考古",
    desc: "依赖读者投稿与线索共享，让散落在个人收藏里的绝版资源重新汇聚。",
  },
  {
    icon: "ri-leaf-line",
    title: "尊重版权",
    desc: "补档以资料保存与怀旧分享为初衷，尊重原作版权，欢迎版权方联系沟通。",
  },
];

const aboutLd = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "关于073漫画网",
  description: "073漫画网是老漫画补档与童年漫画考古平台，专注经典老番与绝版资源归档。",
  url: "https://toonlegacy.github.io/#about",
};

export default function About() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100/60 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutLd) }}
      />
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <p className="mb-2 inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-700">
              <span className="h-px w-6 bg-primary-500"></span>
              关于本站
            </p>
            <h2 className="text-2xl md:text-4xl">073 漫画网的考古初心</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              073漫画网是一间面向怀旧读者的老漫画补档站。我们把散落在磁带、旧杂志与记忆深处的
              童年漫画、经典老番和绝版资源，按年代一点点归档、修复、标注，做成一份能随时翻开的
              童年地图。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们相信每一部老作品都值得被重新看见。无论它属于哪个年代、来自哪家美术电影制片厂，
              只要它曾照亮过谁的童年，就值得被好好保存、继续被翻找。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {["童年记忆", "经典老番", "绝版资源", "老漫画补档"].map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs text-primary-800"
                >
                  {t}
                </span>
              ))}
            </div>

            <div className="mt-8 rounded-lg border border-background-200 bg-background-50 p-5">
              <h3 className="font-heading text-lg">联系我们 / 投稿</h3>
              <p className="mt-2 text-sm text-foreground-600">
                提供线索、分享藏品、交流补档，欢迎来信。
              </p>
              <ul className="mt-4 space-y-2 text-sm text-foreground-700">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-700"></i>
                  contact@073comics.example.com
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-time-line text-primary-700"></i>
                  周一至周五 10:00 - 18:00 处理投稿
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-primary-700"></i>
                  线上档案库，全年无休开放
                </li>
              </ul>
            </div>
          </div>

          <div>
            <h3 className="mb-5 font-heading text-xl md:text-2xl">我们坚持的四件事</h3>
            <div className="grid gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-800">
                    <i className={p.icon}></i>
                  </span>
                  <h4 className="mt-3 font-heading text-base">{p.title}</h4>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}